import { render, staticRenderFns } from "./DynamicDataView.vue?vue&type=template&id=63104d0c"
import script from "./DynamicDataView.vue?vue&type=script&lang=js"
export * from "./DynamicDataView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports